import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { EmspUserInvoiceBaseModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/emsp-user-invoice-base.model';
import { useTranslation } from 'react-i18next';

export interface EmspBoInvoiceStatusFilterStateControllerProps {
  value: EmspUserInvoiceBaseModel['status'];
  onRemove: FilteredItemProps['onRemove'];
}

export const EmspBoInvoiceStatusFilterStateController = ({
  value,
  onRemove,
}: EmspBoInvoiceStatusFilterStateControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <FilteredItem
      icon="file-05"
      label={t(`delmonicos-shared-sdk.enums-invoice-status.${value}`)}
      onRemove={onRemove}
    />
  );
};
